import React from 'react';
import { useSelector } from 'react-redux';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import { selectAppReady } from '@lib/selectors';
import { isAnyMobile } from '@lib/services/navigatorService';

import { ContentLoader } from '../components';
import LumaBot, { LumaBotProps } from '../LumaBot';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden',
    },
    wrapper: {
      background: theme.palette.background.default,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
      animation: 'slideInUp 1s',
    },
    wrapperDesktop: {
      maxHeight: 'calc(100% - 58px)',
      margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px 0`,
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
      borderRadius: 6,
    },
    readOnly: {
      pointerEvents: 'none',
    },
    '@keyframes slideInUp': {
      '0%': {
        opacity: 0.7,
        transform: 'translateY(28px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  });

const isMobile = isAnyMobile();

export interface WidgetLumaBotProps extends Omit<LumaBotProps, 'classes'>, WithStyles<typeof styles> {}

const WidgetLumaBot: React.FC<WidgetLumaBotProps> = ({ classes, className, ...rest }) => {
  const appReady = useSelector(selectAppReady);

  return (
    <div className={classnames(classes.root, className, { [classes.readOnly]: rest.readOnly })}>
      <div className={classnames(classes.wrapper, { [classes.wrapperDesktop]: !isMobile })}>
        {appReady && <LumaBot {...rest} />}
        {!appReady && <ContentLoader />}
      </div>
    </div>
  );
};

export default withStyles(styles, { name: 'WidgetLumaBot' })(WidgetLumaBot);
